import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import ReactModal from 'react-modal';
import { Button, CircularProgress, FormControl, FormHelperText, Grid, InputLabel, Select } from '@mui/material';
import { getStoreStatusChip } from '../_helpers/mappers';
import _ from 'lodash';
import { mobilizeiConvertrService } from '../_services/mobilizei/convertr.service';

ReactModal.setAppElement('#root')

const customStyles = {
    overlay: {
        backgroundColor: 'rgba(10, 10, 10, 0.45)',
        zIndex: 999
    },
    content: {
        height: 'fit-content',
        width: '35%',
        margin: 'auto'
    }
};

const useStyles = makeStyles(() => ({
    title: {
        marginTop: 0
    },
    helpButton: {
        position: 'absolute',
        top: 12,
        right: 0
    },
    fullWidthShrink: {
        width: '133%'
    },
    statusTooltipContainer: {
        marginBottom: 15,
        marginTop: 5
    }
}))

function ChangeStoreStatusDialog({ data, isOpen, onClose, onDataUpdate }) {
    const classes = useStyles();

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        currentStatus: '',
        status: '',
        trialEndsAt: ''
    })

    const [errors, setErrors] = useState({
        status: null,
        trialEndsAt: null
    })

    useEffect(() => {
        setFormData({
            ...formData,
            currentStatus: _.get(data, 'status', '')
        })
    }, [data]);

    const handleChange = (e) => {
        let newFormData = { ...formData };
        newFormData[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setFormData(newFormData);
    }

    const handleSave = () => {
        setLoading(true);

        const errors = {};
        setErrors({});

        const requiredMsg = "Este campo é obrigatório.";

        if (_.isEmpty(formData.status)) {
            errors['status'] = requiredMsg;
        }

        if (_.isEmpty(errors)) {
            delete formData['currentStatus'];

            mobilizeiConvertrService.updateStoreStatus(data.id, formData.status)
                .then(() => {
                    onDataUpdate();
                    onClose();
                })
                .catch((e) => {
                    alert(`Não foi possível alterar o status da loja.`)
                })
                .finally(() => setLoading(false))
        } else {
            setLoading(false);
            setErrors(errors);
        }
    }

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={() => onClose()}
            style={customStyles}
        >
            <h2 align="center" className={classes.title}>Alterar status da loja</h2>

            <Grid container alignItems="flex-start" spacing={2}>
                <Grid item xs={12}>
                    <InputLabel shrink>Status atual</InputLabel>
                    <div className={classes.statusTooltipContainer}>
                        {getStoreStatusChip(formData.currentStatus)}
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <FormControl className={classes.formControl} error={!!errors.status} fullWidth>
                        <InputLabel htmlFor="status" shrink>Novo status</InputLabel>
                        <Select
                            native
                            value={formData.status}
                            onChange={handleChange}
                            inputProps={{
                                name: 'status',
                                id: 'status',
                            }}
                        >
                            <option value="">Selecione o novo status...</option>
                            <option value={'active'}>Ativo</option>
                            <option value={'suspended'}>Suspenso</option>
                        </Select>
                        {errors.status && <FormHelperText>{errors.status}</FormHelperText>}
                    </FormControl>
                </Grid>

                <Grid container justifyContent="center" item xs={12}>
                    {loading ? <CircularProgress /> :
                        <Button variant="contained" color="primary" onClick={handleSave} sx={{ fontSize: '18px'}}>
                            Salvar
                        </Button>
                    }
                </Grid>
            </Grid>
        </ReactModal>
    )
}

export default ChangeStoreStatusDialog;